import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=a77b98dc&scoped=true&lang=pug&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77b98dc",
  null
  
)

export default component.exports